import { TallyPair, Tally } from 'ep-bt-field-agent-proxy';
import { TallyValidationResult } from 'ep-bt-controls';

export class EpbtFaTallyModel {

    constructor(tallyString?: string) {
        if (tallyString) {
            this.m_tallyValues = this.ParseTally(tallyString);
        } else {
            this.m_tallyValues = [];
        }
    }

    private m_tallyValues: any[];
    public totalTallyVolume?: any;
    public totalTallyVolumeMetric?: any;
    public totalTallyArea?: any;
    public totalTallyAreaMetric?: any;
    public totalTallyLength2?: any;
    public totalTallyLengthMetric?: any;

    public static validateTally(tallyString: string, productLengths: any[]): TallyValidationResult {
        let result = TallyValidationResult.IsValid;

        if (tallyString == null || tallyString == '') {
            result = TallyValidationResult.IsEmpty;
        } else {
            if (tallyString.includes('@')) {
                result = TallyValidationResult.PackTalliesNotSupported;
            } else {
                const pairs = [] = tallyString.split(',');
                const tallyPairs: Array<TallyPair> = [];

                pairs.forEach(p => {
                    const tallyPieces = [] = p.split('/');

                    if (tallyPieces.length != 2) {
                        result = TallyValidationResult.TallyPairIsNotComplete;
                    } else {
                        const tp = new TallyPair();
                        tp.pieces = tallyPieces[0];
                        tp.length = tallyPieces[1];
                        tallyPairs.push(tp);
                    }
                });
                if (result == TallyValidationResult.IsValid) {
                    // at this point we should have List<tallyPair> populated
                    tallyPairs.forEach(tp => {
                        // validate Pieces
                        const pieces = parseFloat(tp.pieces);
                        if (pieces == 0) {
                            result = TallyValidationResult.InvalidTallyPieces;
                        }
                        const length = parseFloat(tp.length);
                        if (length <= 0) {
                            result = TallyValidationResult.InvalidTallylength;
                        }
                        // check if tally length belongs to the list of
                        // available lengths specified for Product
                        const l: string = productLengths.find(p => p.trim() == length.toString().trim());
                        if (l == null) {
                            result = TallyValidationResult.LengthNotAvailable;
                        }
                    });
                }
            }
        }
        return result;
    }

    public static getDescription(e: any, id: number): string {
        return e[e[id].toString() + 'Description'];
    }

    private ParseTally(tallyString: string): any[] {
        const result: any[] = [];
        if (!tallyString) {
            return result;
        }

        const tallysplits = tallyString.split(',');
        if (tallysplits.length > 0) {
            tallysplits.forEach(tally => {

                const tallyPieces: string[] = tally.split('/');
                if (tallyPieces.length == 2) {
                    const quantity = parseFloat(tallyPieces[0]);
                    const length = parseFloat(tallyPieces[1]);

                    // Don't add zero quantities.
                    if (quantity > 0) {

                        const index = result.findIndex(item => item.length == length);
                        if (index < 0) {
                            result.push({
                                length: length,
                                quantity: quantity
                            });
                        } else {
                            result.forEach(element => {
                                if (element.length == length) {
                                    element.quantity += quantity;
                                }
                            });
                        }
                    }
                }
            });
        }

        return result;
    }

    public get isPackTally(): boolean {
        const index = this.tallyString.indexOf('@');
        return index != -1;
    }

    public get tallyString(): string {

        // let tallies: string;
        if (this.m_tallyValues.length == 0) {
            return '';
        }

        const talliesArray: any[] = [];
        this.m_tallyValues.forEach(element => {
            talliesArray.push(element.quantity + '/' + element.length);
        });
        return talliesArray.filter(Boolean).join(', ');
    }

    public add(quantity: string, length: string) {
        this.addTally(new EpbtFaTallyModel(quantity + '/' + length));
    }

    public addTally(otherTally: EpbtFaTallyModel) {
        if (otherTally == null) {
            return;
        }
        otherTally.m_tallyValues.forEach(result => {
            const index = this.m_tallyValues.findIndex(item => item.length == result.length);
            if (index < 0) {
                this.m_tallyValues.push({
                    length: result.length,
                    quantity: result.quantity
                });
            } else {
                this.m_tallyValues.forEach(element => {
                    if (element.length == result.length) {
                        element.quantity += result.quantity;
                    }
                });
            }

        });
    }

    public get pairs(): TallyPair[] {

        const pairs: TallyPair[] = [];

        this.m_tallyValues.forEach(element => {
            const pair = new TallyPair();
            pair.pieces = element.length;
            pair.length = element.quantity;
            pairs.push(pair);
        });
        return pairs;
    }

    /// <summary>
    /// The total number of pieces.
    /// </summary>

    public get totalTallyPieces(): number {
        let quantity = 0;
        this.m_tallyValues.forEach(element => {
            quantity += element.quantity;
        });
        return quantity;
    }

    /// <summary>
    /// Total length of all pieces added together.
    /// </summary>

    public get totalTallyLength(): number {
        let total = 0;
        this.m_tallyValues.forEach(element => {
            total += element.quantity * element.length;
        });
        return total;
    }



    // / <summary>
    // / Calculate tally totals
    // / Area,Volume and length based on passed.
    // / Note that multi-width tally is not supported here yet
    // / Note then you need to pass conversion parameters here
    // / f.e
    // /  decimal perConvInchToMillimetre =
    // /  ServiceLocator.Instance.BisTrackServices.PortalDataService.GetPerConversion((int)PerDefaults.Inch, (int)PerDefaults.Millimetre,
    // /                            0, false, 0, 0, 0, 0);
    // / parameters
    // / </summary>
    // / <param name="thickness">Product thikckness</param>
    // / <param name="width">Product width</param>
    // / <param name="isImperial"></param>
    // / <param name="perConvInchToMillimetre"></param>
    // / <param name="perConvMillimetreToInch"></param>
    // / <param name="perConvFootToMetre"></param>
    // / <param name="totalTallyArea"></param>
    // / <param name="totalTallyVolume"></param>
    // / <param name="totalTallyLength"></param>
    public getTotalsFromTally(
        thickness: number,
        width: number,
        isImperial: boolean,
        perConvInchToMillimetre: number,
        perConvMillimetreToInch: number,
        perConvFootToMetre: number,
        perCubicMetreToBoardFoot: number
    ) {
        // Metric
        let thicknessMetric: number;
        let widthMetric: number;
        let lengthMetric: number;
        // Imperial
        let thicknessImperial: number;
        let widthImperial: number;
        let lengthImperial: number;
        // Area
        let totalAreaMetric = 0;
        let totalAreaImperial = 0;
        // Volume
        let totalVolumeMetric = 0;
        let totalVolumeImperial = 0;
        // Length
        let totalLengthMetric = 0;
        let totalLengthImperial = 0;
        let totalPieces = 0;

        if (isImperial) {
            thicknessImperial = thickness;
            thicknessMetric = thickness * perConvInchToMillimetre;
            widthImperial = width;
            widthMetric = width * perConvInchToMillimetre;
        } else {
            // Metric
            thicknessMetric = thickness;
            thicknessImperial = thickness * perConvMillimetreToInch;
            widthImperial = width * perConvMillimetreToInch;
            widthMetric = width;
        }

        this.m_tallyValues.forEach(element => {

            if (element.quantity > 0) {
                if (isImperial) {
                    // length in feet
                    lengthImperial = element.length;
                    lengthMetric = element.length * perConvFootToMetre;
                } else {
                    // Length in metres
                    lengthMetric = element.length;
                    lengthImperial = element.length * perConvMillimetreToInch;
                }

                totalPieces = totalPieces + element.quantity;
                // Total length
                totalLengthMetric = totalLengthMetric + lengthMetric * element.quantity;
                totalLengthImperial = totalLengthImperial + lengthImperial * element.quantity;
                // Total Volume
                totalVolumeMetric = totalVolumeMetric + (thicknessMetric / 1000) * (widthMetric / 1000) * (lengthMetric * element.quantity); // Board foot

                // Volume can be calculated using commented line as well
                // totalVolumeImperial = totalVolumeImperial + thicknessImperial  * (widthImperial / 12) * (lengthImperial * quantity); // Board foot
                totalVolumeImperial = totalVolumeMetric * perCubicMetreToBoardFoot;

                // Area
                totalAreaMetric = totalAreaMetric + (widthMetric / 1000) * (lengthMetric * element.quantity);
                totalAreaImperial = totalAreaImperial + (widthImperial / 12) * (lengthImperial * element.quantity);
            }

        });

        this.totalTallyArea = totalAreaImperial;
        this.totalTallyVolume = totalVolumeImperial;
        this.totalTallyLength2 = totalLengthImperial;

        this.totalTallyAreaMetric = totalAreaMetric;
        this.totalTallyVolumeMetric = totalVolumeMetric;
        this.totalTallyLengthMetric = totalLengthMetric;


    }

}
